import { SortEnum } from "../graphql/graphql-types.gen.mjs";
import { isEqual } from "lodash-es";
import { computed, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "#app";
const _options = [
  { label: "mostPopular", value: void 0 },
  { label: "priceLowToHigh", value: { price: SortEnum.Asc } },
  { label: "priceHighToLow", value: { price: SortEnum.Desc } }
];
const selectedOption = ref();
export function useSortBy() {
  const route = useRoute();
  const { replace } = useRouter();
  onMounted(() => {
    const sortByUrlQuery = route.query.sort ? JSON.parse(route.query.sort?.toString() || "") : "";
    const sortedOption = sortByUrlQuery ? _options.find((option) => isEqual(option.value, sortByUrlQuery)) || _options[0] : _options[0];
    selectedOption.value = {
      ...sortedOption,
      label: sortedOption.label
    };
  });
  const options = computed(
    () => _options.map((option) => ({
      ...option,
      label: option.label
    }))
  );
  watch(selectedOption, (newValue) => {
    if (newValue) {
      replace({
        query: {
          ...route?.query || {},
          sort: newValue.value ? JSON.stringify(newValue.value) : void 0
        }
      }).catch((err) => {
        if (err.name !== "NavigationDuplicated") {
          throw err;
        }
      });
    }
  });
  watch(
    () => route,
    (newRoute) => {
      if (newRoute.query.sort) {
        const option = options.value.find(
          (option2) => isEqual(
            option2.value,
            JSON.parse(
              newRoute.query.sort?.toString() || ""
            )
          )
        );
        if (option) selectedOption.value = option;
      }
    },
    {
      immediate: true
    }
  );
  const defaultSortOption = { position: SortEnum.Asc };
  return {
    options,
    selectedOption,
    defaultSortOption
  };
}
